/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of email recipient
 * @export
 */
export const RecipientType = {
    To: 'to',
    Cc: 'cc',
    Bcc: 'bcc'
} as const;
export type RecipientType = typeof RecipientType[keyof typeof RecipientType];


export function instanceOfRecipientType(value: any): boolean {
    for (const key in RecipientType) {
        if (Object.prototype.hasOwnProperty.call(RecipientType, key)) {
            if (RecipientType[key as keyof typeof RecipientType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecipientTypeFromJSON(json: any): RecipientType {
    return RecipientTypeFromJSONTyped(json, false);
}

export function RecipientTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientType {
    return json as RecipientType;
}

export function RecipientTypeToJSON(value?: RecipientType | null): any {
    return value as any;
}

export function RecipientTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RecipientType {
    return value as RecipientType;
}

